export function buildSummary(template, formdata, schema, steps) {
  let parts = template.split('<perStep>')
  let preSteps = parts[0]
  parts = parts[1].split('</perStep>')
  let postSteps = parts[1]

  parts = parts[0].split('<perField>')
  let preField = parts[0]
  parts = parts[1].split('</perField>')
  let postField = parts[1]
  let perField = parts[0]

  let formatted = preSteps

  for (const [steps_key, steps_value] of Object.entries(steps)) {
    if (steps_key != 'end_step') {
      let stepContents = []
      steps_value.elements.forEach(element => {
        if (formdata[element]) {
          if (schema[element]['type'] === 'select') {
            stepContents.push(perField.replace('{field}', schema[element].label).replace('{value}', schema[element]['items'][formdata[element]]['label']))
          }
          else {
            stepContents.push(perField.replace('{field}', schema[element].label).replace('{value}', formdata[element]))
          }
        }
      });

      if (stepContents.length > 0) {
        formatted += preField.replace('{step}', steps_value.label)
        stepContents.forEach(content => {
          formatted += content
        })
        formatted += postField
      }

    }
  }
  formatted += postSteps

  return formatted
}